module.exports = __webpack_public_path__ + "img/21.69b9be2c.jpg";